import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from "react-query";
import { resolveDynamicUrl } from "../shared/utils";
import { API_CACHE_KEYS, ApiRoutes } from "../constants/apiRoutes";
import { IOrganization } from "../shared/types";
import axios from "axios";
import { CUSTOMER_CACHE_REFRESH_INTERVAL_MS, isCustomerSyncWindowActive } from "../shared/customerSync";

// export const useGetOrganizations = (
//   options?: UseQueryOptions<IOrganization[], null, IOrganization[]>
// ) => {
//   return useQuery<IOrganization[], null, IOrganization[]>(
//     API_CACHE_KEYS.ORGANIZATIONS,
//     async () => {
//       const { data } = await axios.get(ApiRoutes.organizations);
//       return data;
//     },
//     { ...options, placeholderData: [] }
//   );
// };
// Function with query param added

export const useGetOrganizations = (
  SearchBy?: string | string[],
  options?: UseQueryOptions<IOrganization[], null, IOrganization[]>
) => {
  return useQuery<IOrganization[], null, IOrganization[]>(
    API_CACHE_KEYS.ORGANIZATIONS,
    async () => {
      const { data } = await axios.get(ApiRoutes.organizations, {
        params: { SearchBy },
      });
      return data;
    },
    {
      ...options,
      placeholderData: [],
      retry: 0,
      staleTime: 0,
      refetchInterval: () => isCustomerSyncWindowActive() ? CUSTOMER_CACHE_REFRESH_INTERVAL_MS : false,
    }
  );
};

export const useUpdateOrganization = (organizationId: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    (data: IOrganization) => {
      return axios.post(
        resolveDynamicUrl(ApiRoutes.updateOrganization, { organizationId }),
        data
      );
    },
    {
      // onSettled, not onSuccess: this endpoint has been observed to save successfully server-side
      // even when the client sees the request as failed (the call site still shows its own
      // success/error message based on that outcome) - invalidating regardless means a save that
      // actually landed doesn't leave every cached read of this organization stale, including
      // QuickQuote's own separate customer-list cache (`[QUOTES, "customers"]`, a different query
      // key from ORGANIZATIONS - Create Quote's customer picker never saw an ORGANIZATIONS-only
      // invalidation) - that mismatch is exactly why Create Quote kept showing the old discount
      // until a manual browser refresh.
      onSettled() {
        queryClient.invalidateQueries(API_CACHE_KEYS.ORGANIZATIONS);
        queryClient.invalidateQueries([API_CACHE_KEYS.QUOTES, "customers"]);
      },
    }
  );
};
